import { 
    SET_CURRENT_SM,
    UNSET_CURRENT_SM
} from '../actions';
const initState = -1;
export const currentSMReducer = (state = initState, action) => {
    switch(action.type) {
        case SET_CURRENT_SM: 
            return action.payload;
        case UNSET_CURRENT_SM:
            return initState;
        default:
            return state;
    }
};